require('./gridImagesSelector.scss');
require('./gridImagesSelector.override.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classnames = require('classnames');
const isEqual = require('lodash/lang/isEqual');
// @ helpers
const { FormattedText } = require('core/i18n').i18n;
const { splitIntoChunks } = require('../../../../loansUtilities/loansHelper');
// @constants
const {
    payrollLoanCommon: { SPLIT_PURPOSES_ITEMS },
} = require('../../../../loansConstants/index');

class GridImagesSelector extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            idImageEvent: null,
            classIconBackground: false
        }
        this.handleToggleBackground = this.handleToggleBackground.bind(this);
    }

    buildListIcons() {
        const {
            images,
            isDragoFeature,
            onChange,
            selectedOptionId,
        } = this.props;
        const {
            classIconBackground,
            idImageEvent,
        } = this.state;


        return splitIntoChunks(images, SPLIT_PURPOSES_ITEMS).map((group, rowIndex) => {
            const row = group.map((image, index) => {
                const id = image.get('id');
                const icon = image.get('icon');
                const text = image.get('text');

                const isSelected = id === selectedOptionId;
                const iconStyles = classnames('icon', icon, 'grid-image-selector__icon', {
                    'grid-image-selector__icon__background': isEqual(idImageEvent, id) && classIconBackground,
                    'grid-image-selector__icon-drago-size-style': isDragoFeature
                });
                const buttonStyles = classnames('grid-image-selector__button');

                let floatingText;
                let selectedIcon;

                if (text) {
                    floatingText = <p className="grid-image-selector__text">{text}</p>;
                }

                if (isSelected) {
                    selectedIcon = <i className="grid-image-selector__icon-success icon-exito"></i>;
                }

                const handleButtonClick = () => {
                    onChange(id);
                };

                return (
                    <div className="col-xs-4 col-lg-3" key={index}>
                        <button
                            onClick={handleButtonClick}
                            className={buttonStyles}
                            onMouseOver={() => this.handleToggleBackground(id)}
                            onMouseLeave={() => this.handleToggleBackground(id)}>
                            <i className={iconStyles} ></i>
                            {selectedIcon}
                            {floatingText}
                        </button>
                    </div>
                );
            });

            return (
                <div key={`items-row-${rowIndex}`} className="row grid-image-selector__equalheight">
                    {row}
                </div>
            );
        });
    }

    handleToggleBackground(id) {
        this.setState({
            idImageEvent: id,
            classIconBackground: !this.state.classIconBackground
        });
    }

    render() {
        const { label } = this.props;
        const listIcons = this.buildListIcons();

        return (
            <article className="grid-image-selector">
                <header className="grid-image-selector__header">
                    <h4 className="grid-image-selector__title">
                        <FormattedText value={label} />
                    </h4>
                </header>
                {listIcons}
            </article>
        );
    }

}


const imagesPrototype = PropTypes.shape({
    id: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    text: PropTypes.string
});

GridImagesSelector.propTypes = {
    images: PropTypes.arrayOf(imagesPrototype).isRequired,
    isDragoFeature: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    selectedOptionId: PropTypes.string,
    label: PropTypes.string,
    textOverImg: PropTypes.func,
    customContentClass: PropTypes.string,
};

GridImagesSelector.defaultProps = {
    images: []
}

module.exports = GridImagesSelector;
